import { message } from 'antd';

message.config({
  duration: 3,
  maxCount: 2,
});

export default message;
